import { render } from 'preact';
import { calculators } from './calculators';

const MOUNT_ELEMENT_ID = 'salary-v1-form-inputs';
const CALCULATOR_KEY = 'salary-v1';

function findMountNode(root = document) {
  if (root instanceof Document) {
    return root.getElementById(MOUNT_ELEMENT_ID);
  }

  if (!(root instanceof Element)) return null;
  if (root.id === MOUNT_ELEMENT_ID) return root;
  return root.querySelector(`[id="${MOUNT_ELEMENT_ID}"]`);
}

function readProps(element) {
  const raw = element.getAttribute('data-wint-props');
  if (!raw) return {};

  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (error) {
    console.warn('Invalid JSON in data-wint-props:', error);
    return {};
  }
}

function mountNode(element) {
  if (element.__wintMounted) return;

  const Calculator = calculators[CALCULATOR_KEY];
  if (!Calculator) {
    console.warn(`Unknown calculator "${CALCULATOR_KEY}" on node:`, element);
    return;
  }

  const props = readProps(element);
  const mountHost = document.createElement('div');

  element.replaceWith(mountHost);
  render(<Calculator {...props} />, mountHost);
  mountHost.__wintMounted = true;
}

function mountAll(root = document) {
  const node = findMountNode(root);
  if (node) mountNode(node);
}

function observeNewMounts() {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        if (node.id === MOUNT_ELEMENT_ID) {
          mountNode(node);
        }

        mountAll(node);
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

if (!window.WintCalculator) {
  window.WintCalculator = { mountAll };
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    mountAll();
    observeNewMounts();
  });
} else {
  mountAll();
  observeNewMounts();
}
